module.exports = __webpack_public_path__ + "static/img/ic_home_fw_map.bacc15ad.png";